// src/components/Sidebar.tsx
import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Collapse,
  Box,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDay";
import EditIcon from "@mui/icons-material/Edit";
import GroupIcon from "@mui/icons-material/Group";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BarChartIcon from "@mui/icons-material/BarChart";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";

const drawerWidth = 240;

const Sidebar: React.FC = () => {
  const [openTurnosFijos, setOpenTurnosFijos] = useState<boolean>(false);

  const handleClickTurnosFijos = () => {
    setOpenTurnosFijos((prev) => !prev);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Toolbar />
      <Box sx={{ flexGrow: 1 }}>
        <List>
          {/* Menú Turnos Fijos con subopciones */}
          <ListItemButton onClick={handleClickTurnosFijos}>
            <ListItemIcon>
              <CalendarTodayIcon />
            </ListItemIcon>
            <ListItemText primary="Turnos Fijos" />
            {openTurnosFijos ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </ListItemButton>
          <Collapse in={openTurnosFijos} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton component={Link} to="/" sx={{ pl: 4 }}>
                <ListItemIcon>
                  <CalendarViewDayIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Lista diaria"
                  primaryTypographyProps={{ variant: "body2" }}
                />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/turnos-fijos"
                sx={{ pl: 4 }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Gestionar turnos"
                  primaryTypographyProps={{ variant: "body2" }}
                />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/turnos-fijos/clientes"
                sx={{ pl: 4 }}
              >
                <ListItemIcon>
                  <GroupIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Clientes"
                  primaryTypographyProps={{ variant: "body2" }}
                />
              </ListItemButton>
            </List>
          </Collapse>
          {/* Reportes */}
          <ListItemButton component={Link} to="/reportes">
            <ListItemIcon>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary="Reportes" />
          </ListItemButton>
          {/* Billetera */}
          <ListItemButton component={Link} to="/flobipay">
            <ListItemIcon>
              <AccountBalanceWalletIcon />
            </ListItemIcon>
            <ListItemText primary="Flobi Pay" />
          </ListItemButton>
          {/* Empleados */}
          <ListItemButton component={Link} to="/empleados">
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Empleados" />
          </ListItemButton>
          {/* Calendario */}
          <ListItemButton component={Link} to="/calendar">
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Calendario" />
          </ListItemButton>
        </List>
      </Box>
      {/* Opción de cuenta en la parte inferior */}
      <Box sx={{ p: 2 }}>
        <ListItemButton component={Link} to="/cuenta">
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Cuenta" />
        </ListItemButton>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
